(function () {


  if (document.querySelector('.content') && document.querySelector('.sidebar .downloadBox')) {
    let mobile = false;

    function addDownloadOnTop() {
      document.querySelector('.content').insertAdjacentElement('afterend', document.querySelector('.sidebar .downloadbox'));
    }

    function revertDownloadPosition() {
      document.querySelector('.sidebar').insertBefore(document.querySelector('.downloadbox'), document.querySelector('.sidebar').firstChild);
    }


    if (window.innerWidth < 991) {
      mobile = true;
      addDownloadOnTop();
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth <= 991 && !mobile) {
        mobile = true;
        addDownloadOnTop();
      } else if (window.innerWidth > 991 && mobile) {
        mobile = false;
        revertDownloadPosition();
      }
    });
  }
})();